export const getters = {
    getUsuarioLogadoNoSistema(state) {
        return state.usuarioLogadoNoSistema;
    },
    getPerfil(state) {
        return state.perfil;
    },
    getMatriculas(state){
        return state.matriculas
    },
    getModulos(state){
        return state.modulos
    }
};

